module.exports = __webpack_public_path__ + "assets/img/shop_btn_end.a445a861.png";